export default {
  height: 12,
  width: 13,
  svg: `
  <svg width="13" height="12" viewBox="0 0 13 12" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.22147 3.37811C0.928838 3.63397 0.917891 4.0607 1.19702 4.33123L6.40051 9.37448C6.547 9.51646 6.74427 9.5872 6.94098 9.58538C7.17021 9.61761 7.41273 9.54917 7.58501 9.38219L12.7852 4.34215C13.0643 4.07162 13.0534 3.64489 12.7607 3.38903C12.4681 3.13316 12.0046 3.14505 11.7255 3.41558L6.99674 7.9987L2.25673 3.40467C1.9776 3.13413 1.5141 3.12224 1.22147 3.37811Z"/>
  </svg>
`
}
